/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Created_ByInputs */

const en_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created By`)
};

const fr_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créé par`)
};

const de_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt von`)
};

const it_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato da`)
};

const ru_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано пользователем`)
};

const es_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado por`)
};

const zh_cn2_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建者`)
};

const ja_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成者`)
};

const hi_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`के द्वारा बनाई गई`)
};

const pt_pt2_options_general_created_by = /** @type {(inputs: Options_General_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado por`)
};

/**
* | output |
* | --- |
* | "Created By" |
*
* @param {Options_General_Created_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_created_by = /** @type {((inputs?: Options_General_Created_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Created_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_created_by(inputs)
	if (locale === "de") return de_options_general_created_by(inputs)
	if (locale === "it") return it_options_general_created_by(inputs)
	if (locale === "ru") return ru_options_general_created_by(inputs)
	if (locale === "es") return es_options_general_created_by(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_created_by(inputs)
	if (locale === "ja") return ja_options_general_created_by(inputs)
	if (locale === "hi") return hi_options_general_created_by(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_created_by(inputs)
	return en_options_general_created_by(inputs)
});